export enum EventBusDetail {
	Values = 'Values',
}
